<template>
  <flow-block-container
    @remove="$emit('remove')"
    @change-time="$emit('change-time', $event)"
    @lock-time="$emit('lock-time', $event)"
    @drag-time="$emit('drag-time', $event)"
    @drag-time-active="$emit('drag-time-active', $event);"
    :show-connection="showConnection"
    :draggablesListVirtualOffsets="draggablesListVirtualOffsets"
    :dragTimeActive="dragTimeActive"
    :item="value">

    <!--
    <pre class="mini-pre">FROM: {{item.from|shortTime}}<br />TO:   {{item.to|shortTime}}</pre>
    <pre class="mini-pre">{{item}}</pre>
    -->
    <div style="display: flex">
      <img height="48" :src="value.config.icon" class="mr-4" @click="onClickGoToUrl"/>
      <div>
        <!-- QUICK SESSION -->
        <!-- {{value.config}} -->
        <inline-editable-text
          class="h4 mb-0"
          @change="onUpdateTitle"
          :value="item.config.title"
          :inline="false"
          :reset-on-update="false"
          :reset-on-cancel="false"
          :lost-focus-is-update="false"
          :is-editable="isEditable"
          />
        <duration-quick-settings
          :value="sessionLength"
          v-if="isEditable"
          @save="onQuickSetDurationTask"
          :showSeconds="false"
          :quickDurationSettings="{
            '0 min': 0 * 60,
            '1 min': 1 * 60,
            '3 min': 3 * 60,
            '5 min': 5 * 60,
            '10 min': 10 * 60,
            '15 min': 15 * 60,
            '20 min': 20 * 60,
            '25 min': 25 * 60,
            '30 min': 30 * 60,
            '45 min': 45 * 60,
            '1 h': 1 * 60 * 60,
            '2 h': 2 * 60 * 60,
            '3 h': 3 * 60 * 60,
            '4 h': 4 * 60 * 60,
            '8 h': 8 * 60 * 60,
          }" />
      </div>
    </div>
  </flow-block-container>
  <!--
  <div class="action-card bg-white action-card-primitive rounded-2 position-relative mb-n6 mx-auto mx-lg-0">
    <div class="p-2 action-card-header bg-white" style="border-radius: 6px">
  <div v-if="showConnection" class="workflow-string position-absolute"></div>
  -->
</template>

<script>
import FlowBlockContainer from './FlowBlockContainer'

export default {
  props: {
    value: {},
    showConnection: { default: true },
    isEditable: { default: true },
    draggablesListVirtualOffsets: { // TODO: vuex?
      type: Object,
    },
    dragTimeActive: { // TODO: vuex?
      type: Boolean,
    },
  },
  watch: {
    value: {
      handler(newValue) {
        this.item = newValue;
      },
      deep: true,
      immediate: true
    }
  },
  data: () => ({
    item: {}
  }),
  computed: {
    sessionLength() {
      return this.value.to - this.value.from
    }
  },
  methods: {
    onUpdate(data) {
      for (var prop in data) {
        // this.item[prop] = data[prop];
        this.$emit("update", { prop, value: data[prop] });
      }
    },
    onUpdateTitle($event) {
      this.$emit('update', { 'config/title': $event })
    },
    onRemove() {
      this.$emit('remove');
    },
    onQuickSetDurationTask(value) {
      this.$emit('change-duration', value)
    },
    onClickGoToUrl() {
      if (this.value.config && this.value.config.url) {
        window.open(this.value.config.url)
      }
    }
  },
  components: {
    FlowBlockContainer
  }
}
</script>

<style>
</style>
